import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LeftNavigationItemType } from '@core/navigation/models/left-navigation/left-navigation-item-type.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { FeaturesDirective } from '@core/features/directives/features.directive';
import { NavigationTaggedLinkComponent } from '@layout/navigation/components/navigation-tagged-link/navigation-tagged-link.component';
import { NavigationLinkComponent } from '@layout/navigation/components/navigation-link/navigation-link.component';
import { LeftNavigationExternalItem, LeftNavigationItem } from '@core/navigation/models/left-navigation/left-navigation-item.interface';
import { NavigationExternalLinkComponent } from '@layout/navigation/components/navigation-external-link/navigation-external-link.component';
import { asNonUndefined, isNotUndefined } from '@kaseya-utils';
import { PermissionDirective } from '@core/permissions/directives/permission.directive';
import { CountryAccessDirective } from '@core/locations/directives/country-access.directive';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { NavigationExternalTaggedLinkComponent } from '@layout/navigation/components/navigation-external-tagged-link/navigation-external-tagged-link.component';

@Component({
  selector: 'itc-left-navigation-item',
  templateUrl: 'left-navigation-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PermissionDirective,
    TranslatePipe,
    FeaturesDirective,
    NavigationTaggedLinkComponent,
    NavigationLinkComponent,
    NavigationExternalLinkComponent,
    CountryAccessDirective,
    NavigationExternalTaggedLinkComponent,
  ],
})
export class LeftNavigationItemComponent {
  readonly isTooltipEnabled = input.required<boolean>();
  readonly navigationItem = input.required<LeftNavigationItem | LeftNavigationExternalItem>();
  readonly topNavigation = input<TopNavigationPath>();
  readonly navigationItemGuard = computed(() => {
    if (!isNotUndefined(this.navigationItem().guard)) {
      return true;
    }
    return asNonUndefined(this.navigationItem().guard)();
  });
  readonly leftNavigationItem = computed(() => this.navigationItem() as LeftNavigationItem);
  readonly leftNavigationExternalItem = computed(() => this.navigationItem() as LeftNavigationExternalItem);
  readonly navigationItemClick = output<void>();
  readonly LeftNavigationItemType = LeftNavigationItemType;
}
